__turbopack_context__.v({
  "mobileNavColumn": "_1YGija_mobileNavColumn",
  "mobileNavItem": "_1YGija_mobileNavItem",
  "navItem": "_1YGija_navItem",
  "navRow": "_1YGija_navRow",
  "root": "_1YGija_root",
  "secondaryNavRareMobileExpand": "_1YGija_secondaryNavRareMobileExpand",
});
